/*
 * COPYRIGHT. HSBC HOLDINGS PLC 2017. ALL RIGHTS RESERVED.
 *
 * This software is only to be used for the purpose for which it has been
 * provided. No part of it is to be reproduced, disassembled, transmitted,
 * stored in a retrieval system nor translated in any human or computer
 * language in any way or for any other purposes whatsoever without the
 * prior written consent of HSBC Holdings plc.
 *
 */

/**
 * author: hao
 */

import { apiFetch } from '../../../apiClient';
import { getSessionDatas } from '../../../utils';
import { apiMap, settings } from '../../../config/constants';
import { showLoaing, updateQianhaiInfo } from '../../App/state/action';

export const SAVE_AO_FORM = "SAVE_AO_FORM";
export const COMPLETE_AO_FORM = "COMPLETE_AO_FORM";

export const saveAOFormAction = (data, questionStatus) => {
    return { type: SAVE_AO_FORM, data, questionStatus }
};

export const completeAOFormAction = (data, questionStatus) => {
    return { type: COMPLETE_AO_FORM, data, questionStatus }
};

/* istanbul ignore next */
export const saveAOForm = (application, answerDetails, questionStatus, qianHaiInfo) => dispatch => {
    dispatch(showLoaing(true))
    return updateApplication(answerDetails, questionStatus, qianHaiInfo)(dispatch)
        .then(res => {
            if (res.respBody && 
                res.respBody.businessInfo
                && res.respBody.businessInfo.qianHaiInfo) {
                dispatch(updateQianhaiInfo(res.respBody.businessInfo.qianHaiInfo))
            }
            dispatch(saveAOFormAction(application, questionStatus))
            dispatch(showLoaing(false))
            return res;
        })
        .catch(error => {
            dispatch(showLoaing(false))
            throw error;
        })
};

/* istanbul ignore next */
export const completeAOForm = (application, answerDetails, questionStatus, qianHaiInfo) => dispatch => {
    dispatch(showLoaing(true))
    return updateApplication(answerDetails, questionStatus, qianHaiInfo)(dispatch)
        .then(res => {
            if (res.respBody && 
                res.respBody.businessInfo
                && res.respBody.businessInfo.qianHaiInfo) {
                dispatch(updateQianhaiInfo(res.respBody.businessInfo.qianHaiInfo))
            }
            dispatch(completeAOFormAction(application, questionStatus))
            dispatch(showLoaing(false))
            return res;
        })
        .catch(error => {
            dispatch(showLoaing(false))
            throw error;
        })

};

/* istanbul ignore next */
const updateApplication = (answerDetails, questionStatus, qianhaiInfo) => (dispatch) => {
    const { applicationId } = getSessionDatas();
    const updateApplicationParams = {
        hostname: settings.hostnameQianhai,
        paramsObj: {
            businessInfo: {
                appId: applicationId,
                answerDetails,
                questionStatus: { ...questionStatus },
                qianHaiInfo: qianhaiInfo
            }
        },
        method: settings.put,
    };
    return apiFetch(apiMap.getQianhai, updateApplicationParams)(dispatch);
}




// WEBPACK FOOTER //
// ./src/views/AOForm/state/action.js